import React, { useEffect, useState } from "react";
import CoreFileUploader from "../../core/inputs/CoreFileUploader";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_POST } from "../../config/constants";
import {
  UPLAOD_DEED_FAIL,
  UPLAOD_DEED_SUCCESS,
} from "../../store/types/deedTypes";
import { resetDeedReducer } from "../../store/actions/deedAction";
import { useNavigate } from "react-router";

export default function DeedProcessorUpload() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [file, setFile] = useState(null);
  const tool = "deed-processor";

  const deedUploadSuccess = useSelector(
    (state) => state?.deed?.deedUploadSuccess,
  );
  const deedUploadError = useSelector((state) => state?.deed?.deedUploadError);
  const deedUploadMessage = useSelector(
    (state) => state?.deed?.deedUploadMessage,
  );

  useEffect(() => {
    if (file) {
      handleUpload();
    }
  }, [file]);

  useEffect(() => {
    if (deedUploadSuccess) {
      dispatch(resetDeedReducer({ deedUploadSuccess: false }));
      navigate("/deed-processor/single");
    }
    if (deedUploadError) {
      alert(deedUploadMessage);
      dispatch(resetDeedReducer({ deedUploadError: false }));
    }
  }, [deedUploadSuccess, deedUploadError]);

  const handleUpload = (event) => {
    event?.preventDefault();
    dispatch(
      api_request(
        API_METHOD_POST,
        "/doc/deed/upload",
        {
          file: file,
        },
        null,
        null,
        UPLAOD_DEED_SUCCESS,
        UPLAOD_DEED_FAIL,
        true,
        true,
      ),
    );
  };

  return (
    <>
      <div
        style={{
          height: "calc(100vh - 68px - 4px)",
          width: "calc(100% + 32px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: "-8px",
          marginTop: "-30px",
        }}
      >
        <CoreFileUploader
          tool={tool}
          handleChange={(file) => {
            if (file) {
              setFile(file);
            }
          }}
          isMulti={false}
          customHelperText="Supported documents : Upload any PDF of deed document."
        />
      </div>
    </>
  );
}
